var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAscending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51967 20.8572L8.91675 21.3837L8.31383 20.8572C3.24378 16.4302 0.666748 12.5646 0.666748 9.16675C0.666748 4.35486 4.42238 0.916748 8.91675 0.916748C13.4111 0.916748 17.1667 4.35486 17.1667 9.16675C17.1667 12.5646 14.5897 16.4302 9.51967 20.8572ZM2.50008 9.16676C2.50008 11.7786 4.61447 15.0642 8.91674 18.9415C13.219 15.0642 15.3334 11.7786 15.3334 9.16676C15.3334 5.40531 12.433 2.75009 8.91674 2.75009C5.40052 2.75009 2.50008 5.40531 2.50008 9.16676ZM6.05276 7.19988H9.95018L4.6019 12.5482L5.80383 13.7501L11.1521 8.40181V12.2992H12.8519V5.50009H6.05276V7.19988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.bdda6ff5fac7f93a58bc2e0c9e246f41.svg";
export { ForwardRef as ReactComponent };